import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography
} from "@mui/material";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CloseIcon from "@mui/icons-material/Close";
import {PrimaryBigButton, SecondaryBigButton} from "../../components/buttons/mainButton";
import React from "react";
import {useTranslation} from "react-i18next";

interface CancelTemplateCreationDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  setClose: () => void;
  onSave: () => Promise<void>;
  isValid: boolean;
}

export default function CancelTemplateCreationDialog(props: CancelTemplateCreationDialogProps): JSX.Element {
  const {open, setOpen, setClose, onSave, isValid} = props;
  const {t} = useTranslation();

  const handleClose = (): void => {
    setOpen(false);
  };

  const handleSave = async (): Promise<void> => {
    await onSave();
    handleClose();
  };

  const handleExit = (): void => {
    setClose();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{display: "flex", justifyContent: "center"}} disableEscapeKeyDown>
      <Divider sx={{height: 4, backgroundColor: "warning.main", borderColor: "warning.main"}} flexItem/>
      <DialogTitle sx={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
        <Box sx={{display: "flex", alignItems: "center"}}>
          <ReportProblemIcon sx={{color: "warning.main", width: 24, height: 24, mr: 1}}/>
          <Typography variant="h2" color="neutral.dark" sx={{fontWeight: "bold"}}>
            {t("email_templates.cancel_dialog.title")}
          </Typography>
        </Box>
        <IconButton onClick={handleClose}>
          <CloseIcon sx={{color: "neutral.main"}}/>
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{pb: 5}}>
        <Typography variant="body1" color="neutral.main" sx={{fontWeight: "unset"}}>
          {t("email_templates.cancel_dialog.warning")}
        </Typography>
      </DialogContent>
      <DialogActions sx={{p: 5, borderTop: "1px solid", borderColor: "ornament.dark"}}>
        <SecondaryBigButton sx={{mr: 0}} label={t("email_templates.cancel_dialog.exit_label")} action={handleExit}/>
        <PrimaryBigButton label={t("email_templates.cancel_dialog.save_label")} action={handleSave} disabled={!isValid}/>
      </DialogActions>
    </Dialog>
  );
}